import React from 'react';
import buildUrl from '../buildUrl';
import {List} from 'immutable';
import {BullseyeIcon} from '@components/icon/BullseyeIcon';
import DashboardSidebar from 'components/pure/admin/DashboardSidebar';
import {MemoIcon} from '@components/icon/MemoIcon';
import {ChartLineUpIcon} from '@components/icon/ChartLineUpIcon';
import {PhoneIcon} from '@components/icon/PhoneIcon';

const sidebarMenu = props => {
  const usingI360Embed = props.sessionUser.i360Embed;

  const makeUrl = item => ({...item, url: `${buildUrl(props)}/${item.url}`});
  const coachingChildren = List([
    {
      name: 'Coaching Meetings',
      url: `coaching-meetings`,
    },
    {name: 'Coaching Activity', url: `coaching-activity`},
    {name: 'Coaching Plans', url: `coaching-plans`},
    {name: 'Team Skills', url: 'team-skills'},
    {name: 'Manager Metrics', url: 'manager-coaching'},
    {name: 'Coach Metrics', url: 'coach-coaching'},
    {name: 'Peer Metrics', url: 'other-coaching'},
  ]).map(makeUrl);

  const callChildren = List([
    {name: 'Activity', url: 'activity'},
    {name: 'Topics', url: 'topics'},
  ]).map(makeUrl);

  return List([
    {
      name: 'Summary',
      icon: MemoIcon,
      url: `${buildUrl(props)}/summary`,
    },
    {
      name: 'Coaching',
      icon: ChartLineUpIcon,
      children: coachingChildren,
    },
    !usingI360Embed && {
      name: 'Activity & Topics',
      icon: PhoneIcon,
      children: callChildren,
    },
    props.showKpiTab && {
      name: 'KPIs',
      icon: BullseyeIcon,
      url: `${buildUrl(props)}/kpi`,
    },
  ]);
};

export default class AdminDashboardSidebar extends React.Component {
  render() {
    return (
      <DashboardSidebar
        sidebarMenu={sidebarMenu(this.props)}
        sidebarOpen={this.props.sidebarOpen}
        className="dashv2-exec"
      />
    );
  }
}
